import React, { ReactElement } from 'react';

export default function Completed (props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='128' viewBox='0 0 128 128' width='128' xmlns='http://www.w3.org/2000/svg'>
            <rect fill='#DEF2F4' height='120' rx='60' width='120' x='4' y='4' />
            <path d='M30.5 69L54.1872 90.3647C54.5821 90.7208 55.1867 90.7057 55.5632 90.3301L98 48' stroke='#0E7680' strokeLinecap='round' strokeWidth='6' />
        </svg>

    );
}
